export default __webpack_public_path__ + "static/media/308f5a49a2fbcf89787694e4b44e2a32.svg";